@if (type) {
  <p-inputgroup [id]="id()" class="p-inputgroup">
    <ng-container *ngTemplateOutlet="innerInput" />
    <p-inputgroup-addon>
      @switch (type) {
        @case ('percent') {
          %
        }
        @case ('currency') {
          $
        }
      }
    </p-inputgroup-addon>
  </p-inputgroup>
} @else {
  <input #theInnerInput pInputText placeholder="{{ placeholder() }}" [formControl]="numberControl" (blur)="onInputBlur($event)" />
}

<ng-template #innerInput>
  <input #theInnerInput pInputText placeholder="{{ placeholder() }}" [formControl]="numberControl" (blur)="onInputBlur($event)" />
</ng-template>
